module.exports = {
    localMediaTitle: "Local MKT",
    sumOfToday:'sum of today',
    cost:'Cost',
    performanceOverview:'Performance Overview',
    basicInformation:'Basic Information',
    dataView:'Data View',
    trackingStatistics:'Tracking Statistics',
    filters:'Filters',
    timeIntervel:'Time Interval',
    dateRange:'Date Range',
    deleteCheckedItem: 'Delete checked item',
    performanceOverviewHelp: 'The statistical data of this module might be different from your platform due to the different time zones of the APP products. The detailed time zone data can be queried in the Report module.',
    dashboard:'Dashboard',
    report:'Report',
    eventMethod:'Event Method',
    campain:'Campaign',
    creatives:'Creatives',
    analysis: 'Analysis',
    eventName:'Event Name',
    setting:'Setting',
    site_id:'Campaign',
    basicData: 'Basic Data',
    uploadCreatives: 'Upload Creatives',
    appName: 'App Name',
    mediasource: 'Media Source',
    click: 'Click',
    conversion: 'Conversion',
    retargeting: 'Retargeting',
    impression: 'Impression',
    cost: 'Cost',
    revenue: 'Revenue',
    cr: 'CR',
    ivr: 'IVR',
    ctr: 'CTR',
    pay: 'Pay',
    payRate: 'Pay Rate',
    login: 'Login',
    loginRate: 'Login Rate',
    retention: 'Retention',
    retentionRate: 'Retention Rate',
    purchase: 'Purchase',
    arpu: 'ARPU',
    filterByProducts: 'Filter by products',
    filterByFormat: 'Filter by format',
    selectMonth: 'Select month',
    imageCreatives: 'Image Creatives',
    videoCreatives: 'Video Creatives',
    amount: 'Amount',
    install: 'Install',
   
    allReport: 'All Report',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    qbr: 'QBR',
    QBR:'QBR',
    Others:'Others',
    others: 'Others',
    advertiser: 'Advertiser',
    country: 'Country',
    kpi: 'KPI',
    dataRange:'Data Range',
    enterAdvertiser: 'Please enter Advertiser',
    enterAppname: 'Please enter App Name',
    enterMediaSource: 'Please enter Media Source',
    source:'Source:',
    apptoken:'App token:',
    currency:'Currency Type:',
    apitoken:'Api token:',
    enterCountry: 'Please enter Country',
    enterSiteid:'Please enter Campaign',
    Install:'Install',
    CTR:'CTR',
    selectsname:'Search product name',
    sorts:'Please select',
    CVR:'CVR',
    cvr:'CVR',
    IMP:'IMP',
    imp_count:'IMP',
    roi:'ROI',
    Click:'Click',
    click_count:'Click',
    install_count: 'Install',
    Sortby:'Sort by',
    All:'All',
    Image:'Image',
    Video:'Video',
    pkg:'PKG Name:',
    agency:'Agency Name:',
    kpirule:'KPI RULE',
    costSetting:'Cost Setting',
    reportid:'Report Index',
    rules:'Rules',
    ok:'Save',
    operate:'Operate',
    price$:'Price($)',
    preprice$:'Reservation price($)',
    placeholder:'Search by Advertiser',
    kindTip:'Kindly Tips：',
    tipsCont:'Please do not fill in any creatives if you do not need to change. We will batch update the creatives you have checked.',
    timerange:'Time Range:',
    timedate:'Time:',
    psd:'Please pick a date',
    psp:'Please select product',
    media:'Please select media',
    ecd:'Edit Creative Data',
    pif:'Please input format',
    product:'Product:',
    products:'Products',
    format:'Format:',
    Export:'Export',
    Format:'Format',
    items:'items：',
    selectf:'Please select format',
    selectp:'Please select product',
    selecta:"Please select time",
    customEvent:'Custom In-app event',
    removeall:'Remove all',
    item:'item',
    Benchmark:'Benchmark',
    Expand:'Expand',
    Collapse:'Collapse',
    installs:'Install',
    inapp:'In-app Event',
    Event:'Events',
    most20:'The maximum number of selected events is 20',
    EditFailed:'Edit Failed',
    mustNumber:'Must be a pure number',
    mustint:'Event unique users and event count value must be an integer',
    mustfloat:'Event conversion and event ratio value must be of numeric type with two decimal places reserved',
    shi:'是',

    liftAdvertising: 'Lift Media',
    campaignSetting: 'Campaign Setting',
    sumOfYesterdayCost: 'sum of yesterday cost',
    settingBasicData: 'Basic Data',
    settingCreatives:'Creatives',
    settingAnalysis: 'Analysis',
    conversionType: 'Conversion Type',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/localMedia/en.js